import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncYoutubeMusicToAppleMusic() {
    return (
        <GuidesPage
            seoData={seoContent.syncYoutubeMusicToAppleMusic}
            sections={<PairSyncGuideContent sourceKey="youtubeMusic" destKey="appleMusic" />}
        />
    );
}
